import request from '@/utils/request'

export function getData (data) {
  return request({
    url: '/demo/demo-list-tree/list',
    method: 'post',
    data
  })
}
